/**!
 * Created by Leonardo Cheslacki on 06/05/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import AuthController from './AuthController';

import WithType from './../helpers/WithType';

import config from './../../../../config';

const {default: {routes: {web}}} = config;

let _this = {};

/**
 *
 */
class AuthWelcome extends AuthController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: {},
            count_index: 0,
            disabled: false
        };

        this.$inputs = {};

        this.isInput = false;

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handleSubmit: function (event) {
            const
                {form} = _this.props,
                {data, disabled} = _this.state,
                _this_frame = _this.getFrame(),
                {occ_form} = _this_frame;

            if (disabled) {
                return _this.stopPropagation(event);
            } else {
                _this.stopPropagation(event);
            }

            if (_this.inObject(occ_form, 'children')) {
                _this.main.postForm(`${_this.$root_uri}/${web.uri_login}`, {[form]: data}, {
                    beforeSend: () => {
                        _this.setState({..._this.state, disabled: true});
                        _this.clearErrors();
                        _this.focus();
                        _this.effectFadeIn(_this_frame, 'occ_preload');
                    },
                    done: ({status, errors, message, route}) => {
                        if (Boolean(status)) {
                            _this.main.redirectRoute(route);
                        } else {
                            _this.getErrors(errors, message);
                        }
                    },
                    fail: (response) => {
                        console.log(response);
                    },
                    always: () => {
                        _this.setState({..._this.state, disabled: false});
                        _this.effectFadeOut(_this_frame, 'occ_preload');
                    }
                });
            }
        },

        /**
         *
         * @param event
         */
        handleKeydown: function (event) {
            const
                {disabled} = _this.state,
                {key} = event,
                _this_frame = _this.getFrame(),
                {occ_form: {children}, occ_message, btn_submit} = _this_frame,
                property = children.find(({state: {focus}}) => Boolean(focus)),
                {name, type, value, mask, placeholder, line_width, value_x, caret_x} = property.state,
                {occ_text: {occ_value}, occ_placeholder, occ_caret} = property;

            if (disabled) {
                return _this.stopPropagation(event);
            }

            if (occ_message.isVisible()) {
                _this.clearErrors();
            }

            // let
            //     bounds_old = occ_value.getBounds(),
            //     width_old = (_this.getObject(bounds_old, 'width') ? bounds_old.width : 0);

            let masked = mask, valued = value;

            if (key === 'Backspace') {
                valued = value.substring(0, value.length - 1);
            } else if (key === 'Tab') {
                _this.stopPropagation(event);
                _this.cycleTabindex(children);
            } else if (key === 'Enter') {
                _this.dispatch(btn_submit, 'click');
            } else if (key.length === 1) {
                valued += key;
            } else {
                return _this.stopPropagation(event);
            }

            if (type === 'password') {
                valued = !_this.isEmpty(valued) ? _this.removeAllSpace(valued) : '';
                masked = '*'.repeat(valued.length);
            } else {
                valued = !_this.isEmpty(valued) ? _this.removeSpaceDuplicate(valued) : '';
                masked = valued;
            }

            _this.setStates({data: {[name]: valued}});
            _this.setStateOccurrence(property, {mask: masked, value: valued});

            occ_value.text = masked;
            occ_placeholder.text = (occ_value.text ? '' : placeholder);

            let
                bounds = occ_value.getBounds(),
                width_current = (_this.getObject(bounds, 'width') ? bounds.width : 0);
            // width_character = (width_current - width_old);

            if (width_current > line_width) {
                occ_value.textAlign = 'right';
                occ_value.x = line_width;
            } else {
                occ_value.textAlign = 'center';
                occ_value.x = value_x;
                occ_caret.x = (caret_x + (width_current / 2));
            }
        },

        /**
         *
         * @param event
         */
        handleOutFocus: function (event) {
            _this.stopPropagation(event);

            if (!_this.isInput) {
                _this.setState({..._this.state, count_index: 0});
                _this.focus();
            }
        },

        /**
         *
         * @param event
         * @param object
         */
        handleFocus: function (event, {_ref}) {
            const {tab_index} = _ref.state;

            _this.isInput = true;

            _this.setState({..._this.state, count_index: tab_index});

            _this.focus(_ref);

            _this.throttle('handle-focus', () => {
                _this.isInput = false;
            }, 500);
        }
    };

    /**
     *
     * @param errors
     * @param message
     */
    getErrors = (errors, message) => {
        const
            {form} = this.props,
            _this_frame = this.getFrame(),
            {occ_form: {children}, occ_message} = _this_frame;

        occ_message.occ_text.text = message.text;
        _this.effectFadeIn(_this_frame, 'occ_message');

        if (this.inObject(errors, form)) {
            for (const field in errors[form]) {
                let error = this.getError(errors[form], field);
                const {occ_pseudo, occ_error} = children.find(({name}) => name === `${form}_${field}`);
                occ_pseudo.visible = true;
                occ_error.text = (error ? error : '');
            }
        }
    };

    clearErrors = () => {
        const
            _this_frame = this.getFrame(),
            {occ_form: {children}, occ_message} = _this_frame;

        _this.effectFadeOut(_this_frame, 'occ_message');
        occ_message.occ_text.text = '';

        for (const property of children) {
            const {occ_pseudo, occ_error} = property;
            occ_error.text = '';
            occ_pseudo.visible = false;
        }
    };

    /**
     *
     * @param children
     */
    cycleTabindex = (children) => {
        this.state.count_index++;
        (this.state.count_index === children.length) && (this.state.count_index = 0);
        this.focus(children[this.state.count_index]);
    };

    /**
     *
     * @param _ref
     */
    focus = (_ref = null) => {
        const {occ_form: {children}} = this.getFrame();

        for (let property of children) {
            const {occ_caret} = property;
            let status = (_ref === property);
            occ_caret.visible = status;
            this.setStateOccurrence(property, {focus: status});
        }

        if (_ref) {
            canvas.style.outline = 'none';
            canvas.setAttribute('tabindex', '0');
            canvas.focus();

            // let input = document.createElement('input'); // experimental
            //
            // input.type = 'text';
            //
            // let ds = document.getElementById('animation_container');
            //
            // ds.append(input);
            //
            // input.focus();
        } else {
            canvas.removeAttribute('tabindex');
            canvas.blur();
        }
    };

    init = () => {
        const
            {form} = this.props,
            _this_current = this.get();

        this.gotoAndStopFrame(_this_current, 1);

        const {btn_submit, occ_form: {children}} = this.getFrame();

        let length = children.length;

        for (let i = 0; i < length; i++) {
            const property = children[i];
            const {occ_text: {occ_value: {x, lineWidth}}, occ_placeholder: {text}, name, occ_caret} = property;

            property.cursor = 'text';

            this.setStateOccurrence(property, {
                ...property.state,
                name: name.replace(`${form}_`, ''),
                type: (/password/g).test(name) ? 'password' : 'text',
                focus: false,
                value_x: x,
                caret_x: occ_caret.x,
                line_width: lineWidth,
                placeholder: text,
                tab_index: i,
                value: '',
                mask: ''
            });

            let alias = `_handleFocus${this.toClassName(name)}`;

            this.inObject(this.$inputs, alias) && property.off('mousedown', this.$inputs[alias]);
            this.$inputs[alias] = property.on('mousedown', this.$functions.handleFocus, false, false, {_ref: property});

            this.endFor(length, i) && this.emit('process_end', {});
        }

        this._handleOutFocus && _this_current.off('click', this._handleOutFocus);
        this._handleOutFocus = _this_current.on('click', this.$functions.handleOutFocus);

        this._handleSubmit && btn_submit.off('click', this._handleSubmit);
        this._handleSubmit = btn_submit.on('click', this.$functions.handleSubmit);

        /**
         *
         *  Add event in the keydown for inputs.
         */
        this.removeListener('keydown', 'keydown-canvas', this.$functions.handleKeydown, () => {
            this.addListener(canvas, 'keydown', 'keydown-canvas', this.$functions.handleKeydown);
        });
    };
}

/**
 *
 * @type {{}}
 */
AuthWelcome.propTypes = {
    current_name: PropTypes.string,
    form: PropTypes.string
};

/**
 *
 * @type {{}}
 */
AuthWelcome.defaultProps = {
    current_name: null,
    form: 'auth'
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(AuthWelcome, {className: 'AuthWelcome'});
